import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../../assets/images/fdss.jpg';
const _hoisted_1 = {
  class: "navbar"
};
const _hoisted_2 = {
  class: "input_main_power"
};
const _hoisted_3 = {
  class: "money_change"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "button_recharge"
};
const _hoisted_6 = {
  class: "button_real"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_notice_bar = _resolveComponent("van-notice-bar");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_area = _resolveComponent("van-area");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_cell_group, {
    inset: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_notice_bar, {
      "left-icon": "volume-o",
      text: "话费电费充值活动开启。地区,运营商,不同价格不同,开卡即享最低92折优惠。充值有任何问题请联系客服。"
    }), _createVNode(_component_van_tabs, {
      class: "main-div"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_tab, {
        title: "电费充值",
        name: "b"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_divider), _createVNode(_component_van_form, null, {
          default: _withCtx(() => [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              name: "radio"
            }, {
              input: _withCtx(() => [_createVNode(_component_van_radio_group, {
                modelValue: $data.power.electricardtype,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.power.electricardtype = $event),
                direction: "horizontal"
              }, {
                default: _withCtx(() => [_createVNode(_component_van_radio, {
                  name: "1"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("国网")])),
                  _: 1
                }), _createVNode(_component_van_radio, {
                  name: "2"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("南网")])),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_van_field, {
              name: "radio"
            }, {
              input: _withCtx(() => [_createVNode(_component_van_radio_group, {
                modelValue: $data.power.electritype,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.power.electritype = $event),
                direction: "horizontal"
              }, {
                default: _withCtx(() => [_createVNode(_component_van_radio, {
                  name: "1"
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("家庭")])),
                  _: 1
                }), _createVNode(_component_van_radio, {
                  name: "2"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("店铺")])),
                  _: 1
                }), _createVNode(_component_van_radio, {
                  name: "3"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("事企业")])),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_van_field, {
              modelValue: $data.power.number,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.power.number = $event),
              label: "户号",
              placeholder: "请输入正确的户号",
              rules: [{
                required: true,
                message: '请填写户号'
              }]
            }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
              modelValue: $setup.result,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.result = $event),
              "is-link": "",
              readonly: "",
              label: "地区选择",
              placeholder: "点击选择省市区",
              onClick: _cache[4] || (_cache[4] = $event => $setup.showArea = true)
            }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
              show: $setup.showArea,
              "onUpdate:show": _cache[6] || (_cache[6] = $event => $setup.showArea = $event),
              position: "bottom"
            }, {
              default: _withCtx(() => [_createVNode(_component_van_area, {
                "area-list": $setup.areaList,
                onConfirm: $setup.onConfirm,
                onCancel: _cache[5] || (_cache[5] = $event => $setup.showArea = false)
              }, null, 8, ["area-list", "onConfirm"])]),
              _: 1
            }, 8, ["show"]), _withDirectives(_createVNode(_component_van_field, {
              modelValue: $data.power.cardno,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.power.cardno = $event),
              label: "证件号",
              placeholder: "请输入身份证号后六位",
              rules: [{
                required: true
              }]
            }, null, 8, ["modelValue"]), [[_vShow, $data.power.electricardtype == 2]]), _createVNode(_component_van_field, {
              modelValue: $data.power.telephone,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.power.telephone = $event),
              label: "手机号",
              placeholder: "请输入正确的手机号",
              rules: [{
                required: true,
                message: '请填写手机号'
              }]
            }, null, 8, ["modelValue"]), _createVNode(_component_van_divider), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pricePowerList, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["button_layout", {
                  active: $data.active_num_power === index + 1
                }]),
                onClick: $event => $data.active_num_power = index + 1
              }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item['rechargePrice']), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item['payPrice']), 1)], 10, _hoisted_4);
            }), 256))])]),
            _: 1
          }), _createElementVNode("div", null, [_createVNode(_component_van_cell_group, {
            style: {
              "font-size": "60px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_van_cell, {
              title: "我的抵扣额度",
              value: $data.wallet + '元'
            }, null, 8, ["value"]), _createVNode(_component_van_cell, {
              title: "可抵扣",
              value: '-' + ($data.pricePowerList[$data.active_num_power - 1]['dk'] > $data.wallet ? $data.wallet : $data.pricePowerList[$data.active_num_power - 1]['dk']) + '元'
            }, null, 8, ["value"])]),
            _: 1
          })]), _createVNode(_component_van_button, {
            type: "primary",
            style: {
              "width": "95%",
              "margin": "0 auto"
            },
            block: "",
            onClick: $options.onSubmit
          }, {
            default: _withCtx(() => [_createTextVNode("立即充值 " + _toDisplayString('(' + ($data.pricePowerList[$data.active_num_power - 1]['dk'] > $data.wallet ? $data.pricePowerList[$data.active_num_power - 1]['price'] - $data.wallet : $data.pricePowerList[$data.active_num_power - 1]['payPrice']) + ')'), 1)]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]), _cache[14] || (_cache[14] = _createElementVNode("div", null, [_createElementVNode("div", {
          class: "amount"
        }, [_createElementVNode("div", {
          class: "amount_tit"
        }, "下单须知"), _createElementVNode("div", {
          class: "content inslow",
          style: {}
        }, [_createElementVNode("p", null, [_createElementVNode("strong", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, [_createElementVNode("span", {
          style: {
            "color": "rgb(255, 0, 0)"
          }
        }, "温馨提示：")])]), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, [_createElementVNode("strong", null, [_createElementVNode("span", {
          style: {
            "color": "rgb(255, 0, 0)"
          }
        }, "充值卡会员可抵扣92-95折扣权益！")]), _createElementVNode("strong", null, [_createElementVNode("span", {
          style: {
            "color": "rgb(255, 0, 0)"
          }
        })])]), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "一、广东,广西,云南,贵州,海南 地区请选择南网！其他地区请选择国网，地区不同价格不同。"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "二、在本系统下单电费/话费期间，请不要在其他的平台同时充值，否则出现问题无法售后。"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "三、请正确填写充值号码，系统为自动化充值，号码充值成功后不接受任何退款请求。"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, "四、欠费的不能冲，同号码未成功前不能连续充值。"), _createElementVNode("img", {
          style: {
            "width": "100%"
          },
          src: _imports_0
        }), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, [_createElementVNode("span", {
          open: "",
          helvetica: "",
          "font-size:": "",
          "font-weight:": "",
          "background-color:": "",
          style: {
            "color": "rgb(255, 0, 0)"
          }
        })]), _createElementVNode("p"), _createElementVNode("p", {
          style: {
            "font-size": "medium",
            "white-space": "normal"
          }
        }, [_createElementVNode("span", {
          open: "",
          helvetica: "",
          "font-size:": "",
          "font-weight:": "",
          "background-color:": "",
          style: {
            "color": "rgb(255, 0, 0)"
          }
        }), _createElementVNode("br")]), _createElementVNode("p", null, [_createElementVNode("br")])])])], -1))]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}